import "./login.8f573587.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7455"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7455"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kdrAP", function(module, exports) {

var $yZzij = parcelRequire("yZzij");
// ---------- helpers ----------
const $eb7a6cf340d32bbf$var$ensureHtml = (s)=>/\.html?$/i.test(s) ? s : `${s}.html`;
const $eb7a6cf340d32bbf$var$strip = (s)=>String(s).replace(/^\/+|\/+$/g, "");
const $eb7a6cf340d32bbf$var$join = (...parts)=>"/" + parts.filter(Boolean).map($eb7a6cf340d32bbf$var$strip).join("/");
const $eb7a6cf340d32bbf$var$toAbs = (u)=>/^[a-z]+:/i.test(u) ? u : `${location.origin}${u.startsWith("/") ? u : "/" + u}`;
function $eb7a6cf340d32bbf$var$resolveToken(tok = "") {
    tok = tok.trim();
    if (tok.startsWith("app:")) return $eb7a6cf340d32bbf$var$join("/app/pages", $eb7a6cf340d32bbf$var$ensureHtml(tok.slice(4).trim()));
    if (tok.startsWith("site:")) return $eb7a6cf340d32bbf$var$join($eb7a6cf340d32bbf$var$ensureHtml(tok.slice(5).trim()));
    return tok;
}
function $eb7a6cf340d32bbf$var$wireLinks(scope = document) {
    scope.querySelectorAll("a[data-href]").forEach((a)=>{
        const path = $eb7a6cf340d32bbf$var$resolveToken(a.getAttribute("data-href") || "");
        a.setAttribute("href", $eb7a6cf340d32bbf$var$toAbs(path));
        a.removeAttribute("data-href");
    });
}
function $eb7a6cf340d32bbf$var$sanitize(html) {
    try {
        const doc = new DOMParser().parseFromString(String(html), "text/html");
        doc.querySelectorAll('script, link[rel="stylesheet"], link[rel="modulepreload"]').forEach((n)=>n.remove());
        return doc.body.innerHTML || String(html);
    } catch  {
        return String(html);
    }
}
// ---------- core loader (FRAG_URLS-first) ----------
const $eb7a6cf340d32bbf$var$fetchCache = new Map();
async function $eb7a6cf340d32bbf$var$loadFragment(rawKey) {
    const key = String(rawKey || "").trim();
    if (!key) return "";
    // Prefer a Parcel-managed URL (no SPA fallbacks, always served)
    const parcelUrl = (0, $yZzij.FRAG_URLS)?.[key];
    if (parcelUrl) {
        if (!$eb7a6cf340d32bbf$var$fetchCache.has(parcelUrl)) $eb7a6cf340d32bbf$var$fetchCache.set(parcelUrl, fetch(parcelUrl).then((r)=>r.ok ? r.text() : ""));
        const viaParcel = await $eb7a6cf340d32bbf$var$fetchCache.get(parcelUrl);
        if (viaParcel && viaParcel.trim()) return viaParcel;
    }
    // Final fallback: fetch by resolved path (useful on simple static servers)
    const resolved = $eb7a6cf340d32bbf$var$resolveToken(key);
    const path = $eb7a6cf340d32bbf$var$ensureHtml(resolved.startsWith("/") ? resolved : "/" + resolved);
    const abs = $eb7a6cf340d32bbf$var$toAbs(path);
    if (!$eb7a6cf340d32bbf$var$fetchCache.has(abs)) $eb7a6cf340d32bbf$var$fetchCache.set(abs, fetch(abs).then((r)=>r.ok ? r.text() : ""));
    const fetched = await $eb7a6cf340d32bbf$var$fetchCache.get(abs);
    if (fetched && fetched.trim()) return fetched;
    console.warn("[loader] include miss", {
        raw: key,
        triedParcel: parcelUrl || null,
        triedPath: abs,
        keys: Object.keys((0, $yZzij.FRAG_URLS) || {})
    });
    return "";
}
async function $eb7a6cf340d32bbf$export$ac8d2aa64d563fe1() {
    const nodes = [
        ...document.querySelectorAll("[data-include]:not([data-included])")
    ];
    await Promise.all(nodes.map(async (el)=>{
        const raw = el.getAttribute("data-include") || "";
        const html = await $eb7a6cf340d32bbf$var$loadFragment(raw);
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html ? $eb7a6cf340d32bbf$var$sanitize(html) : `<div class="text-sm text-red-700 bg-red-50 border border-red-200 p-2 rounded">Missing include: ${raw}</div>`;
        // ✅ Instead of replacing the <div> itself, replace only its children
        while(el.firstChild)el.removeChild(el.firstChild);
        for (const child of [
            ...wrapper.children
        ])el.appendChild(child);
        el.setAttribute("data-included", "1");
        $eb7a6cf340d32bbf$var$wireLinks(el);
    }));
    $eb7a6cf340d32bbf$var$wireLinks(document);
    // ✅ Notify that all includes are loaded (optional global hook)
    document.dispatchEvent(new Event("includes:ready"));
    return true;
}
// ---------- expose + boot ----------
window._irecruit = {
    FRAG_URLS: $yZzij.FRAG_URLS,
    injectIncludes: $eb7a6cf340d32bbf$export$ac8d2aa64d563fe1,
    wireLinks: $eb7a6cf340d32bbf$var$wireLinks
};
if (!window.__irecruitLoaderBooted) {
    window.__irecruitLoaderBooted = true;
    async function startIncludes() {
        await $eb7a6cf340d32bbf$export$ac8d2aa64d563fe1();
        // 🔹 Dispatch global ready event
        document.dispatchEvent(new Event("includes:ready"));
        console.log("[loader] includes:ready fired");
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", startIncludes, {
        once: true
    });
    else startIncludes();
}

});
parcelRegister("yZzij", function(module, exports) {

$parcel$export(module.exports, "FRAG_URLS", () => $78bc8c922fa31da1$export$54d52d02707458fa);
// parcel-served URLs

var $lVbMk = parcelRequire("lVbMk");

var $4XrHc = parcelRequire("4XrHc");

var $1r8Ha = parcelRequire("1r8Ha");

var $kUetv = parcelRequire("kUetv");

var $ifTca = parcelRequire("ifTca");

var $4InwM = parcelRequire("4InwM");
const $78bc8c922fa31da1$export$54d52d02707458fa = {
    "/includes/header.html": (0, (/*@__PURE__*/$parcel$interopDefault($lVbMk))),
    "/includes/hero.html": (0, (/*@__PURE__*/$parcel$interopDefault($4XrHc))),
    "/includes/features.html": (0, (/*@__PURE__*/$parcel$interopDefault($1r8Ha))),
    "/includes/workflow.html": (0, (/*@__PURE__*/$parcel$interopDefault($kUetv))),
    "/includes/pricing.html": (0, (/*@__PURE__*/$parcel$interopDefault($ifTca))),
    "/includes/footer.html": (0, (/*@__PURE__*/$parcel$interopDefault($4InwM)))
};

});
parcelRegister("lVbMk", function(module, exports) {
module.exports = import.meta.resolve("8QR8Q");

});

parcelRegister("4XrHc", function(module, exports) {
module.exports = import.meta.resolve("9dGQe");

});

parcelRegister("1r8Ha", function(module, exports) {
module.exports = import.meta.resolve("LxdXl");

});

parcelRegister("kUetv", function(module, exports) {
module.exports = import.meta.resolve("hRvcr");

});

parcelRegister("ifTca", function(module, exports) {
module.exports = import.meta.resolve("kwQHp");

});

parcelRegister("4InwM", function(module, exports) {
module.exports = import.meta.resolve("e6U5F");

});



parcelRegister("aCdVm", function(module, exports) {

$parcel$export(module.exports, "http", () => $7ba84108399d7d07$export$7d6f1c8842f9f527);
$parcel$export(module.exports, "API_BASE", () => $7ba84108399d7d07$export$d43f2f435f160490);
// /src/api/http.js

var $iqWLU = parcelRequire("iqWLU");
/**
 * Parcel replaces process.env.VAR at build time.
 * DO NOT use optional chaining or dynamic access with process.env.
 */ const $7ba84108399d7d07$var$IS_BROWSER = typeof window !== "undefined";
// These are replaced to string literals by Parcel at build time
const $7ba84108399d7d07$var$NODE_ENV = "production"; // "development" or "production"
const $7ba84108399d7d07$var$ENV_BASE = "https://irecruit-api.webpipl.com/api/v1"; // from .env.development / .env.production
/**
 * Priority for API base:
 * 1) window.__API_BASE_URL__  (runtime override from HTML, optional)
 * 2) process.env.BASE_URL     (injected by Parcel from .env.*)
 * 3) Fallback by NODE_ENV
 */ const $7ba84108399d7d07$var$FALLBACK_BASE = $7ba84108399d7d07$var$NODE_ENV === "production" ? "http://localhost:3000/api/v1" : "http://localhost:3000/api/v1";
const $7ba84108399d7d07$var$RAW_BASE = $7ba84108399d7d07$var$IS_BROWSER && window.__API_BASE_URL__ || $7ba84108399d7d07$var$ENV_BASE || $7ba84108399d7d07$var$FALLBACK_BASE;
// Normalize base so origin and path are easy to handle
const $7ba84108399d7d07$var$BASE = new URL($7ba84108399d7d07$var$RAW_BASE, $7ba84108399d7d07$var$IS_BROWSER ? window.location.origin : "http://localhost");
const $7ba84108399d7d07$var$BASE_ORIGIN = $7ba84108399d7d07$var$BASE.origin; // e.g. http://localhost:3000
const $7ba84108399d7d07$var$BASE_PATH = $7ba84108399d7d07$var$BASE.pathname.replace(/\/+$/, ""); // e.g. /api/v1 (no trailing /)
// Helpful log during dev serves
if ($7ba84108399d7d07$var$NODE_ENV === "development") console.log("[http] API BASE =", $7ba84108399d7d07$var$BASE.href);
function $7ba84108399d7d07$var$resolveUrl(inputPath) {
    // Absolute URL? use as-is
    if (/^https?:\/\//i.test(inputPath)) return inputPath;
    // Ensure leading slash
    const p = inputPath.startsWith("/") ? inputPath : `/${inputPath}`;
    // If caller already included the base path (/api/v1), don't duplicate it
    if ($7ba84108399d7d07$var$BASE_PATH && (p.startsWith($7ba84108399d7d07$var$BASE_PATH + "/") || p === $7ba84108399d7d07$var$BASE_PATH)) return $7ba84108399d7d07$var$BASE_ORIGIN + p;
    // Otherwise, prefix with base path
    return $7ba84108399d7d07$var$BASE_ORIGIN + $7ba84108399d7d07$var$BASE_PATH + p;
}
function $7ba84108399d7d07$var$isFormData(body) {
    return typeof FormData !== "undefined" && body instanceof FormData;
}
async function $7ba84108399d7d07$var$request(method, url, data = null, customHeaders = {}) {
    const token = (0, $iqWLU.getToken)();
    const form = $7ba84108399d7d07$var$isFormData(data);
    // Only set JSON header for non-FormData requests
    const headers = {
        ...customHeaders
    };
    if (!form) headers["Content-Type"] = headers["Content-Type"] || "application/json";
    if (token) headers["Authorization"] = `Bearer ${token}`;
    const config = {
        method: method,
        headers: headers
    };
    if (method !== "GET" && method !== "HEAD") config.body = form ? data : JSON.stringify(data ?? {});
    const finalUrl = $7ba84108399d7d07$var$resolveUrl(url);
    try {
        const res = await fetch(finalUrl, config);
        const contentType = res.headers.get("content-type") || "";
        const isJson = contentType.includes("application/json");
        const body = isJson ? await res.json() : await res.text();
        if (!res.ok) {
            const isAuthFailure = res.status === 401;
            const isLoginAttempt = typeof url === "string" && url.includes("/auth/login");
            if (isAuthFailure && !isLoginAttempt) setTimeout(()=>(0, $iqWLU.logout)(), 1000);
            throw {
                status: res.status,
                message: (isJson ? body?.message : null) || "Request failed",
                data: body
            };
        }
        return body;
    } catch (err) {
        throw {
            status: err.status || 500,
            message: err.message || "Network error",
            data: err.data || null
        };
    }
}
const $7ba84108399d7d07$export$7d6f1c8842f9f527 = {
    get: (url, headers)=>$7ba84108399d7d07$var$request("GET", url, null, headers),
    post: (url, data, headers)=>$7ba84108399d7d07$var$request("POST", url, data, headers),
    put: (url, data, headers)=>$7ba84108399d7d07$var$request("PUT", url, data, headers),
    patch: (url, data, headers)=>$7ba84108399d7d07$var$request("PATCH", url, data, headers),
    del: (url, headers)=>$7ba84108399d7d07$var$request("DELETE", url, null, headers)
};
const $7ba84108399d7d07$export$d43f2f435f160490 = $7ba84108399d7d07$var$BASE.href;

});
parcelRegister("iqWLU", function(module, exports) {

$parcel$export(module.exports, "setAuth", () => $d6b83e8ac5e88f0f$export$df3ccf56dd2dacd5);
$parcel$export(module.exports, "getAuthData", () => $d6b83e8ac5e88f0f$export$6909b85c7215230c);
$parcel$export(module.exports, "getToken", () => $d6b83e8ac5e88f0f$export$257b2d10b709d8ef);
$parcel$export(module.exports, "getUser", () => $d6b83e8ac5e88f0f$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getAccessToken", () => $d6b83e8ac5e88f0f$export$84773cc9bf7dbe87);
$parcel$export(module.exports, "logout", () => $d6b83e8ac5e88f0f$export$a0973bcfe11b05c9);
$parcel$export(module.exports, "isAuthenticated", () => $d6b83e8ac5e88f0f$export$83d11f23a23d4a7c);
// auth.js (updated)
const $d6b83e8ac5e88f0f$var$AUTH_KEY = "irecruit_auth";
const $d6b83e8ac5e88f0f$var$REFRESH_URL = "/api/auth/refresh"; // <-- change to your backend route
const $d6b83e8ac5e88f0f$var$CLOCK_SKEW_S = 30; // tolerate small clock drift
function $d6b83e8ac5e88f0f$export$df3ccf56dd2dacd5(data) {
    if (data?.token && data?.user) {
        const toSave = {
            token: data.token,
            user: data.user
        };
        if (data.refreshToken) toSave.refreshToken = data.refreshToken;
        if (data.tokenType) toSave.tokenType = data.tokenType; // e.g., "Bearer"
        localStorage.setItem($d6b83e8ac5e88f0f$var$AUTH_KEY, JSON.stringify(toSave));
    }
}
function $d6b83e8ac5e88f0f$export$6909b85c7215230c() {
    try {
        return JSON.parse(localStorage.getItem($d6b83e8ac5e88f0f$var$AUTH_KEY));
    } catch  {
        return null;
    }
}
function $d6b83e8ac5e88f0f$export$257b2d10b709d8ef() {
    return $d6b83e8ac5e88f0f$export$6909b85c7215230c()?.token || null;
}
function $d6b83e8ac5e88f0f$export$49f610610113aa98() {
    return $d6b83e8ac5e88f0f$export$6909b85c7215230c()?.tokenType || "Bearer";
}
function $d6b83e8ac5e88f0f$export$7cbf767827cd68ba() {
    return $d6b83e8ac5e88f0f$export$6909b85c7215230c()?.user || null;
}
function $d6b83e8ac5e88f0f$export$c33a4269214e2ec4() {
    return $d6b83e8ac5e88f0f$export$7cbf767827cd68ba()?.role || null;
}
/** Decode JWT payload safely (returns null for non-JWT tokens) */ function $d6b83e8ac5e88f0f$var$parseJwt(token) {
    try {
        const parts = token.split(".");
        if (parts.length !== 3) return null;
        const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const json = decodeURIComponent(atob(b64).split("").map((c)=>"%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)).join(""));
        return JSON.parse(json);
    } catch  {
        return null;
    }
}
function $d6b83e8ac5e88f0f$var$isJwtExpired(token, skewSeconds = $d6b83e8ac5e88f0f$var$CLOCK_SKEW_S) {
    const payload = $d6b83e8ac5e88f0f$var$parseJwt(token);
    if (!payload?.exp) return false; // treat non-JWT or no exp as not-expired (cannot verify)
    const now = Math.floor(Date.now() / 1000);
    return payload.exp <= now + skewSeconds;
}
/**
 * Try to refresh the access token using a stored refreshToken.
 * Expects the backend to respond with { token?, accessToken?, refreshToken?, user?, tokenType? }.
 * Returns the new access token string on success, or null on failure.
 */ async function $d6b83e8ac5e88f0f$var$refreshAccessToken(refreshUrl = $d6b83e8ac5e88f0f$var$REFRESH_URL) {
    const data = $d6b83e8ac5e88f0f$export$6909b85c7215230c();
    const refreshToken = data?.refreshToken || data?.refresh_token;
    if (!refreshToken) return null;
    try {
        const res = await fetch(refreshUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                refreshToken: refreshToken
            })
        });
        if (!res.ok) return null;
        const json = await res.json();
        const newToken = json.token || json.accessToken || json.access_token || null;
        if (!newToken) return null;
        const newRefresh = json.refreshToken || json.refresh_token || refreshToken;
        const tokenType = json.tokenType || json.token_type || data?.tokenType || "Bearer";
        const user = json.user || data.user || null;
        $d6b83e8ac5e88f0f$export$df3ccf56dd2dacd5({
            token: newToken,
            user: user,
            refreshToken: newRefresh,
            tokenType: tokenType
        });
        return newToken;
    } catch  {
        return null;
    }
}
async function $d6b83e8ac5e88f0f$export$84773cc9bf7dbe87(opts = {}) {
    const { refresh: refresh = true, autoLogout: autoLogout = true } = opts;
    const token = $d6b83e8ac5e88f0f$export$257b2d10b709d8ef();
    if (!token) return null;
    // If it's a JWT and expired/near-expired, try to refresh:
    if (refresh && $d6b83e8ac5e88f0f$var$isJwtExpired(token)) {
        const newTok = await $d6b83e8ac5e88f0f$var$refreshAccessToken();
        if (newTok) return newTok;
        if (autoLogout) $d6b83e8ac5e88f0f$export$a0973bcfe11b05c9();
        return null;
    }
    // Non-JWT or still valid JWT:
    return token;
}
async function $d6b83e8ac5e88f0f$export$11a51455c5740ca6(opts = {}) {
    const token = await $d6b83e8ac5e88f0f$export$84773cc9bf7dbe87(opts);
    if (!token) return {};
    return {
        Authorization: `${$d6b83e8ac5e88f0f$export$49f610610113aa98()} ${token}`
    };
}
function $d6b83e8ac5e88f0f$export$83d11f23a23d4a7c() {
    const token = $d6b83e8ac5e88f0f$export$257b2d10b709d8ef();
    if (!token) return false;
    try {
        // If JWT, verify exp; if not a JWT, treat presence as "authenticated"
        const payload = $d6b83e8ac5e88f0f$var$parseJwt(token);
        if (!payload?.exp) return true;
        const now = Math.floor(Date.now() / 1000);
        return payload.exp > now;
    } catch  {
        return false;
    }
}
function $d6b83e8ac5e88f0f$export$a0973bcfe11b05c9() {
    localStorage.removeItem($d6b83e8ac5e88f0f$var$AUTH_KEY);
    window.location.replace("/app/pages/login.html");
}

});


parcelRegister("025gH", function(module, exports) {

$parcel$export(module.exports, "showSpinner", () => $00644632abe0f272$export$2a7a135fa1ec651f);
$parcel$export(module.exports, "hideSpinner", () => $00644632abe0f272$export$95fec50f68454318);
/**
 * Attach a spinner to a button and disable it
 */ function $00644632abe0f272$export$2a7a135fa1ec651f(button, label = "Processing...") {
    if (!button) return;
    button.disabled = true;
    button.dataset.originalText = button.innerHTML;
    button.innerHTML = `
    <svg class="inline w-4 h-4 mr-2 text-white animate-spin" viewBox="0 0 24 24" fill="none">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z">
      </path>
    </svg>
    ${label}
  `;
}
function $00644632abe0f272$export$95fec50f68454318(button) {
    if (!button) return;
    button.innerHTML = button.dataset.originalText || "Submit";
    button.disabled = false;
}
function $00644632abe0f272$export$d09d53953454b2c6(message = "Loading...") {
    if (document.getElementById("fullscreen-loader")) return;
    const overlay = document.createElement("div");
    overlay.id = "fullscreen-loader";
    overlay.className = "fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50";
    overlay.innerHTML = `
    <div class="flex items-center space-x-3 text-white text-lg">
      <svg class="w-6 h-6 animate-spin" viewBox="0 0 24 24" fill="none">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="white" stroke-width="4"></circle>
        <path class="opacity-75" fill="white"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z">
        </path>
      </svg>
      <span>${message}</span>
    </div>
  `;
    document.body.appendChild(overlay);
}
function $00644632abe0f272$export$58a03c6bafa35138() {
    const overlay = document.getElementById("fullscreen-loader");
    if (overlay) overlay.remove();
}

});

parcelRegister("i7xfM", function(module, exports) {

$parcel$export(module.exports, "showSuccess", () => $d312ace932024ff2$export$d841eba85c078f0b);
$parcel$export(module.exports, "showError", () => $d312ace932024ff2$export$3879b24e8245693d);
$parcel$export(module.exports, "showInfo", () => $d312ace932024ff2$export$3ddc711ac21275cd);
let $d312ace932024ff2$var$toastContainer = null;
function $d312ace932024ff2$var$createToastContainer() {
    $d312ace932024ff2$var$toastContainer = document.createElement("div");
    $d312ace932024ff2$var$toastContainer.id = "toast-container";
    $d312ace932024ff2$var$toastContainer.className = `
		fixed top-6 left-1/2 -translate-x-1/2 
		z-[9999] space-y-2 
		pointer-events-none
	`;
    document.body.appendChild($d312ace932024ff2$var$toastContainer);
}
function $d312ace932024ff2$export$f6cef6fcf9ca4e17(type, message) {
    console.log("\uD83D\uDCE3 Showing toast:", type, message);
    if (!$d312ace932024ff2$var$toastContainer) $d312ace932024ff2$var$createToastContainer();
    if (!message || typeof message !== "string") message = "Unexpected error occurred";
    const bgClass = {
        success: "bg-green-100 text-green-800 border-green-300",
        error: "bg-red-100 text-red-800 border-red-300",
        info: "bg-blue-100 text-blue-800 border-blue-300"
    }[type];
    const toast = document.createElement("div");
    toast.className = `
  flex items-start w-full max-w-sm sm:max-w-xs p-4 text-sm border rounded-lg shadow-lg
  break-words whitespace-normal leading-snug space-x-2 ${bgClass}
`;
    toast.innerHTML = `
    <div class="text-sm font-medium">${message}</div>
    <button type="button" class="ml-auto -mx-1.5 -my-1.5 text-gray-500 hover:text-gray-900 rounded-lg p-1" aria-label="Close">
      <span class="sr-only">Close</span>
      <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M4.29 4.3a1 1 0 011.42 0L10 8.6l4.3-4.3a1 1 0 011.4 1.4L11.4 10l4.3 4.3a1 1 0 01-1.4 1.4L10 11.4l-4.3 4.3a1 1 0 01-1.4-1.4L8.6 10 4.3 5.7a1 1 0 010-1.4z" clip-rule="evenodd"/>
      </svg>
    </button>`;
    toast.querySelector("button").addEventListener("click", ()=>toast.remove());
    setTimeout(()=>{
        toast.classList.add("opacity-0", "transition-opacity", "duration-500");
        setTimeout(()=>toast.remove(), 500);
    }, 6000);
    $d312ace932024ff2$var$toastContainer.appendChild(toast);
}
function $d312ace932024ff2$export$d841eba85c078f0b(msg) {
    $d312ace932024ff2$export$f6cef6fcf9ca4e17("success", msg);
}
function $d312ace932024ff2$export$3879b24e8245693d(msg) {
    $d312ace932024ff2$export$f6cef6fcf9ca4e17("error", msg);
}
function $d312ace932024ff2$export$3ddc711ac21275cd(msg) {
    $d312ace932024ff2$export$f6cef6fcf9ca4e17("info", msg);
}

});


parcelRequire("kdrAP");
/**
 * Basic field validators
 */ function $c7a05c9bf0a7b8cf$export$2e85a6f149681784(value) {
    return value?.trim() !== "";
}
function $c7a05c9bf0a7b8cf$export$18148d12c805c5b0(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
function $c7a05c9bf0a7b8cf$export$8fe860a115a1e636(value, min) {
    return value.length >= min;
}
function $c7a05c9bf0a7b8cf$export$c9f461152c658a8b(value, max) {
    return value.length <= max;
}
function $c7a05c9bf0a7b8cf$export$722e052e3bf23441(value1, value2) {
    return value1 === value2;
}
function $c7a05c9bf0a7b8cf$export$ed692cabb252e59b(form, rules) {
    const errors = {};
    let valid = true;
    for(const field in rules){
        const input = form.elements[field];
        const value = input?.value || "";
        const fieldRules = rules[field];
        for (const rule of fieldRules){
            if (rule === "required" && !isRequired(value)) {
                errors[field] = "This field is required";
                valid = false;
                break;
            }
            if (rule === "email" && !isValidEmail(value)) {
                errors[field] = "Invalid email address";
                valid = false;
                break;
            }
            if (rule.startsWith("min:")) {
                const min = parseInt(rule.split(":")[1], 10);
                if (!$c7a05c9bf0a7b8cf$export$8fe860a115a1e636(value, min)) {
                    errors[field] = `Minimum ${min} characters required`;
                    valid = false;
                    break;
                }
            }
            if (rule.startsWith("max:")) {
                const max = parseInt(rule.split(":")[1], 10);
                if (!$c7a05c9bf0a7b8cf$export$c9f461152c658a8b(value, max)) {
                    errors[field] = `Maximum ${max} characters allowed`;
                    valid = false;
                    break;
                }
            }
        }
    }
    return {
        valid: valid,
        errors: errors
    };
}
function $c7a05c9bf0a7b8cf$export$1f19495d74053127(form, errors) {
    Object.keys(errors).forEach((field)=>{
        const input = form.elements[field];
        if (!input) return;
        let errorEl = input.nextElementSibling;
        if (!errorEl || !errorEl.classList.contains("form-error")) {
            errorEl = document.createElement("div");
            errorEl.className = "form-error text-sm text-red-600 mt-1";
            input.parentNode.appendChild(errorEl);
        }
        errorEl.textContent = errors[field];
    });
}
function $c7a05c9bf0a7b8cf$export$b7702f01a27b2311(form) {
    const errors = form.querySelectorAll(".form-error");
    errors.forEach((el)=>el.remove());
}



var $aCdVm = parcelRequire("aCdVm");

var $025gH = parcelRequire("025gH");

var $i7xfM = parcelRequire("i7xfM");

var $iqWLU = parcelRequire("iqWLU");

var $88jT0 = parcelRequire("88jT0");

var $gUeH9 = parcelRequire("gUeH9");
console.log("\u2705 login.js loaded");
if ((0, $iqWLU.isAuthenticated)()) window.location.replace("/app/pages/dashboard.html");
window.addEventListener("error", (e)=>{
    console.error("\uD83D\uDD25 Global JS error caught:", e.message);
});
const $889c51e1c682fe22$var$loginForm = document.getElementById("loginForm");
const $889c51e1c682fe22$var$loginBtn = document.getElementById("loginBtn");
$889c51e1c682fe22$var$loginForm.addEventListener("submit", async (e)=>{
    e.preventDefault();
    console.log("\uD83D\uDCE8 Login submitted");
    const email = $889c51e1c682fe22$var$loginForm.email.value.trim();
    const password = $889c51e1c682fe22$var$loginForm.password.value.trim();
    if (!(0, $c7a05c9bf0a7b8cf$export$2e85a6f149681784)(email) || !(0, $c7a05c9bf0a7b8cf$export$18148d12c805c5b0)(email)) {
        (0, $i7xfM.showError)("Please enter a valid email");
        return;
    }
    if (!(0, $c7a05c9bf0a7b8cf$export$2e85a6f149681784)(password)) {
        (0, $i7xfM.showError)("Password is required");
        return;
    }
    $889c51e1c682fe22$var$loginBtn.disabled = true;
    (0, $025gH.showSpinner)();
    try {
        const res = await (0, $aCdVm.http).post(`/auth/login`, {
            email: email,
            password: password
        });
        if (res?.success && res.token && res.user) {
            (0, $iqWLU.setAuth)(res);
            await (0, $88jT0.initSession)();
            console.log("\u2705 Session saved:", res.token);
            (0, $i7xfM.showSuccess)("Login successful!");
            setTimeout(()=>{
                window.location.assign("/app/pages/dashboard.html");
            // Optional
            }, 1000);
        } else (0, $gUeH9.handleError)(err, "Login failed");
    } catch (err1) {
        (0, $gUeH9.handleError)(err1, "Login failed");
    } finally{
        (0, $025gH.hideSpinner)();
        $889c51e1c682fe22$var$loginBtn.disabled = false;
    }
});




//# sourceMappingURL=login.fed92316.js.map
